module.exports = __webpack_public_path__ + "static/img/6.3f0c413.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/list/6.png
// module id = H4OO
// module chunks = 1